import { forwardRef, SVGProps, useId } from 'react';

export const SingleSparkleIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
  const id = useId();
  const filterId = `singleSparkle_shadow_${id}`;
  const gradientId = `singleSparkle_gradient_${id}`;

  return (
    <svg viewBox="1 1 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
      <g filter={`url(#${filterId})`}>
        <path
          d="M15.2453 8.78673C11.2806 9.27424 10.2743 10.2805 9.78673 14.2453C9.74506 14.5849 9.25494 14.5849 9.21327 14.2453C8.72576 10.2806 7.71949 9.27434 3.7547 8.78673C3.4151 8.74506 3.4151 8.25494 3.7547 8.21327C7.71936 7.72576 8.72566 6.71949 9.21327 2.7547C9.25494 2.4151 9.74506 2.4151 9.78673 2.7547C10.2742 6.71936 11.2805 7.72566 15.2453 8.21327C15.5849 8.25494 15.5849 8.74506 15.2453 8.78673Z"
          fill={`url(#${gradientId})`}
        />
        <path
          d="M8.46875 2.66309C8.61838 1.44562 10.3816 1.44562 10.5312 2.66309C10.7737 4.63445 11.1288 5.64442 11.7422 6.25781C12.3556 6.87118 13.3655 7.2263 15.3369 7.46875C16.5544 7.61838 16.5544 9.38162 15.3369 9.53125C13.3655 9.77366 12.3556 10.1288 11.7422 10.7422C11.1288 11.3556 10.7737 12.3655 10.5312 14.3369C10.3816 15.5544 8.61838 15.5544 8.46875 14.3369C8.22634 12.3655 7.8712 11.3556 7.25781 10.7422C6.64442 10.1288 5.63447 9.7737 3.66309 9.53125C2.44562 9.38162 2.44562 7.61838 3.66309 7.46875C5.63445 7.22634 6.64442 6.8712 7.25781 6.25781C7.87118 5.64442 8.2263 4.63447 8.46875 2.66309Z"
          stroke="white"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <filter
          id={filterId}
          x="0"
          y="0"
          width="19"
          height="19"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <linearGradient id={gradientId} x1="9.5" y1="2.5" x2="9.5" y2="14.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0ED6A9" />
          <stop offset="1" stopColor="#818CF8" />
        </linearGradient>
      </defs>
    </svg>
  );
});

SingleSparkleIcon.displayName = 'SingleSparkleIcon';
